import React, {useEffect, useState} from 'react';
// Каркас страницы — стили Зала славы: разделы устроены одинаково и выглядеть
// должны одинаково. Свое (очки, пояснение, перенос заголовка) — в своем файле
import '../GloryHallPage/GloryHallPage.css';
import './BestCollectionsPage.css';
import PageButton from '../../elements/PageButton/PageButton';
import Pagination from '../../elements/Pagination/Pagination';
import {usePageAnalytics} from '../../../hooks/analytics/usePageAnalytics';
import {API_BASE} from '../../../utils/apiConfig';
import {REGISTRY_SINGLETON} from '../../../scenes/Registry';
import {BestCollectionsUserItem} from './BestCollectionsUserItem';
import {BestCollectionsInfo} from './BestCollectionsInfo';
import FloatingBackButton from '../../elements/FloatingBackButton/FloatingBackButton';

const PAGE_ID = 'BestCollectionsPage';
const PAGE_SIZE = 10;

/**
 * «Лучшие коллекции»: постраничный список игроков по очкам коллекции
 * (User.collectionPoints) — по аналогии с Залом славы, где список по рейтингу.
 */
function BestCollectionsPage({onBack, onUserClick}) {
  const [users, setUsers] = useState([]);
  // Сам игрок: сервер отдает его место и очки отдельно (см.
  // /users/best-collections); гостю — null
  const [me, setMe] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  usePageAnalytics(PAGE_ID);

  useEffect(() => {
    const fetchBestCollections = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetch(`${API_BASE}/users/best-collections?limit=${PAGE_SIZE}&page=${page}`, {
          credentials: 'include',
        });
        if (!res.ok) throw new Error('Failed to fetch best collections');
        const data = await res.json();
        setUsers(data.users || []);
        setMe(data.me || null);
        setTotalPages(data.totalPages || 1);
      } catch (e) {
        console.error('Best collections error', e);
        setError('Не удалось загрузить лучшие коллекции');
      } finally {
        setLoading(false);
      }
    };

    fetchBestCollections();
  }, [page]);

  const handlePageChange = (newPage) => {
    REGISTRY_SINGLETON.getSoundManager().playMenuButtonClick();
    setPage(newPage);
  };

  return (
    <>
      <FloatingBackButton onBack={onBack} pageId={PAGE_ID}/>

      <h1 className="glory-hall-page-title">
        Лучшие<br className="best-collections-page-title-mobile-break"/> коллекции
      </h1>

      {loading && <p className="glory-hall-page-status best-collections-page-status">Загрузка...</p>}
      {error && <p className="glory-hall-page-status glory-hall-page-status_error best-collections-page-status">{error}</p>}

      {/* Шапка списка — в стиле плашки игрока */}
      {!loading && !error && users.length > 0 && (
        <div className="glory-hall-page-header">
          <span className="glory-hall-page-header_place">Место</span>
          <span className="best-collections-page-header_points text-attention">Очки коллекции</span>
        </div>
      )}

      {!loading && !error && (
        <>
          {users.length === 0 ? (
            <p className="glory-hall-page-status best-collections-page-status">Список лучших коллекций пока пуст</p>
          ) : (
            <>
              {/* Своя плашка над списком — только когда игрока нет на этой
                  странице: иначе он увидел бы себя дважды */}
              {me && !users.some((user) => user.id === me.id) && (
                <div className="glory-hall-page-own-item">
                  <BestCollectionsUserItem
                    user={me}
                    isCurrentUser
                    onClick={() => onUserClick(me.id, me.name)}
                    pageId={PAGE_ID}
                    buttonId={'own_user'}
                  />
                </div>
              )}

              <div className="glory-hall-page-list">
                {users.map((user, index) => (
                  <BestCollectionsUserItem
                    key={user.id}
                    user={user}
                    isCurrentUser={Boolean(me) && user.id === me.id}
                    onClick={() => onUserClick(user.id, user.name)}
                    pageId={PAGE_ID}
                    buttonId={`user_${index}`}
                  />
                ))}
              </div>
              <Pagination currentPage={page} totalPages={totalPages} onPageChange={handlePageChange}/>
            </>
          )}
        </>
      )}

      {/* Правило подсчета — всегда, в том числе при пустом списке и ошибке:
          от загрузки списка оно не зависит */}
      <BestCollectionsInfo/>

      <div className="main-menu-buttons glory-hall-page-buttons">
        <PageButton onClick={onBack} pageId={PAGE_ID} buttonId="back">
          Назад
        </PageButton>
      </div>
    </>
  );
}

export default BestCollectionsPage;
